import { useQuery } from '@tanstack/react-query'

import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getKasanStatuses } from '../../apis/kasanStatuses'
import type { KasanStatusItem } from '../../types'

// V3 専用. 加算 status 一覧取得 (read-only). 失敗時は空配列で fallback.
export const useKasanStatusesQuery = (yakurekiId: string | undefined) => {
  return useQuery<KasanStatusItem[]>({
    queryKey: [...queryKeys.checkpoints.detail(yakurekiId ?? ''), 'v3'],
    queryFn: async () => {
      if (!yakurekiId) return []
      const response = await getKasanStatuses(yakurekiId)
      return response.data.kasan_statuses
    },
    enabled: !!yakurekiId,
    staleTime: 1000 * 60 * 2,
  })
}
